/* eslint-disable no-unused-vars */
import { api, setToken } from "@/axios";
import { encryptData, decryptData } from "@/utils/helpers";
import { deleteCacheDB } from "@/utils/cacheDB";
import axios from "axios";

const user = decryptData(
  localStorage.getItem("userInfo"),
  process.env.VUE_APP_SECRET_KEY
);

const state = {
  loggedIn: !!localStorage.getItem("userInfo"),
  user: user || {},
  attachmentId: "",
  uploadProgress: "",
  message: "",
  userMessage: "",
  attachmentUrl: "",
  fetchUserBranch: [],
  loginLoading: false,
  is2FaActive: false,
  updateNotification: null,
  showUpdateBanner: false,
  validateSession: {}
};

const mutations = {
  auth_success(state) {
    const user = decryptData(
      localStorage.getItem("userInfo"),
      process.env.VUE_APP_SECRET_KEY
    );
    state.loggedIn = true;
    state.user = user;
  },
  set_error_message(state, message) {
    state.message = message;
  },
  set_user_message(state, message) {
    state.userMessage = message;
  },
  auth_error(state) {
    state.status = "error";
  },
  set_attchmentId(state, val) {
    state.attachmentId = val;
  },
  set_attchmentUrl(state, val) {
    state.attachmentUrl = val;
  },
  upload_progress(state, val) {
    state.uploadProgress = val;
  },
  logout(state) {
    state.status = "";
    state.token = "";
    state.user = {};
    state.isLoggedIn = false;
  },
  set_branch(state, val) {
    state.fetchUserBranch = val;
  },
  login_progress(state, val) {
    state.loginLoading = val;
  },
  setUpdateNotification(state, notification) {
    state.updateNotification = notification;
  },
  setShowUpdateBanner(state, show) {
    state.showUpdateBanner = show;
  },
  set_validate_session(state, val) {
    state.validateSession = val;
  }
};

const actions = {
  async login({ commit, dispatch }, { vm, payload }) {
    try {
      commit("set_loading", true, { root: true });
      state.message = "";
      state.userMessage = "";
      const auth = await api.post("/auth", payload).catch(err => {
        const message = err.response && err.response.data.message;
        const msg = message.split(",");
        if (err.response.status == 400) {
          commit("set_error_message", msg && msg[1]);
          throw new Error(`${message}`);
        } else {
          commit("set_user_message", msg[1]);
        }
      });
      const token =
        auth.data && auth.data.result && auth.data.result.access_token;
      const user = auth.data && auth.data.result && auth.data.result.users;
      const branches =
        auth.data && auth.data.result && auth.data.result.branches;
      const employ = user && user.employ;
      const userData = {
        id: user.id,
        employId: user.employId,
        full_name: employ.full_name,
        user_name: user.user_name,
        isOther: user.isOther,
        userRole: user.userRole,
        profile: employ && employ.attachment && employ.attachment.path,
        isSystemUser: employ && employ.isSystemUser,
        description: employ.description,
        token: token,
        tenantId: user.tenantId,
        userBranchId: user.branchId,
        bussinessLogoUrl: user?.settings[0]?.logoPath,
        businessBranches: branches,
        is2FaActive: user.twoFactorAuthEnabled,
        currentUserSession: auth.data && auth.data.result.currentSession,
        tenant2Fa: user && user.tenant && user.tenant.is2faEnabled
      };
      if (user && token) {
        const userInfo = encryptData(userData, process.env.VUE_APP_SECRET_KEY);
        localStorage.setItem("userInfo", userInfo);
        setToken(token);
      }
      commit("auth_success");
      commit("setNavOpenState", true, { root: true });
      vm.$toasted.success(auth.data.error || auth.data.message).goAway("3000");
      commit("set_loading", false, { root: true });
      console.log("Login successful, user should be redirected");
    } catch (err) {
      commit("set_loading", false, { root: true });
      localStorage.removeItem("userInfo");
    }
  },
  logout({ commit }, { vm }) {
    commit("logout");
    commit("services/clear_services", null, { root: true });
    localStorage.removeItem("userInfo");
    localStorage.removeItem("userPermissions");
    localStorage.removeItem("updateBannerClosed");
    localStorage.removeItem("bannerUpdateInfo");
    localStorage.removeItem("dataTableSortPreference");
    localStorage.clear();
    sessionStorage.clear();

    // Clear IndexedDB
    const dbName = "ReportsDB";
    const request = indexedDB.deleteDatabase(dbName);

    request.onerror = event => {
      console.error("Error deleting database:", event.target.error);
    };

    request.onsuccess = event => {
      console.log("Database deleted successfully", event);
    };
    deleteCacheDB();

    vm.$toasted.error("You have been logged out").goAway("3000");
    state.loggedIn = false;
    vm.$router.push("/login");
  },
  setBannerVisibility({ commit }, isVisible) {
    commit("setShowUpdateBanner", isVisible);
  },
  async checkUpdateNotification({ commit }) {
    try {
      console.log("Checking for update notifications...");
      const bannerClosed = localStorage.getItem("updateBannerClosed");
      console.log("Banner closed status:", bannerClosed);
      if (bannerClosed === "true") {
        console.log("Banner was previously closed, not showing");
        commit("setShowUpdateBanner", false);
        localStorage.setItem("bannerUpdateInfo", "checked");
        return;
      }
      console.log("Fetching notification data from API...");
      const response = await axios.get(
        "https://directus.gilgitapp.com/items/updates_notification"
      );
      console.log("API response:", response.data);
      const notificationData = response.data.data;
      if (notificationData && notificationData.length > 0) {
        const ucemrUpdate = notificationData.find(
          item => item.id === 6 && item.ucemr === true
        );
        console.log("Found UCEMR update:", ucemrUpdate);
        if (ucemrUpdate) {
          commit("setUpdateNotification", ucemrUpdate);
          commit("setShowUpdateBanner", true);
          console.log("Banner should now be visible");
        } else {
          console.log("No UCEMR update found");
        }
      } else {
        console.log("No notification data found");
      }
      localStorage.setItem("bannerUpdateInfo", "checked");
    } catch (error) {
      console.error("Failed to fetch update notification", error);
      commit("setShowUpdateBanner", false);
      localStorage.setItem("bannerUpdateInfo", "checked");
    }
  },
  async registerBussiness({ commit }, { vm, payload }) {
    try {
      commit("set_loading", true, { root: true });
      const register = await api.post("/auth/register", payload);
      vm.$toasted
        .show(`${register.data.message}, Bussiness registered successfully`)
        .goAway("3000");
      vm.$router.push("/login");
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async validateSession({ commit }, { vm, payload }) {
    try {
      const response = await api.post(
        "/auth/validate-session?action=check",
        payload
      );
      console.log(response.data, "response.data");

      commit("set_validate_session", response.data);
    } catch (error) {
      commit("set_validate_session", false);
    }
  },
  async uploadAttachment({ commit, dispatch }, { file, id, vm }) {
    const config = {
      onUploadProgress: function(progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        commit("upload_progress", percentCompleted);
      }
    };

    const compressImage = async imageFile => {
      return new Promise(resolve => {
        const reader = new FileReader();

        // Check if the file is already a Blob
        if (imageFile instanceof Blob) {
          reader.onload = event => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");

              // Adjust canvas size to desired image size
              canvas.width = 800; // Adjust the width as needed
              canvas.height = (800 * img.height) / img.width;

              // Draw image on canvas
              ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

              // Convert canvas content to base64-encoded JPEG
              canvas.toBlob(
                blob => {
                  const compressedFile = new File([blob], "compressed.jpg", {
                    type: "image/jpeg"
                  });
                  resolve(compressedFile);
                },
                "image/jpeg",
                0.7 // Adjust the quality (0.7 means 70% quality)
              );
            };
          };
          reader.readAsDataURL(imageFile);
        } else {
          // If the file is not a Blob, resolve with the original file
          resolve(imageFile);
        }
      });
    };

    let formData = new FormData();

    if (Array.isArray(file) && typeof file[0] === "object") {
      for (const f of file) {
        const compressedFile = await compressImage(f);
        formData.append("attachment", compressedFile);
      }
    } else {
      const compressedFile = await compressImage(file);
      formData.append("attachment", compressedFile);
    }
    if (id) {
      commit("set_loading", true, { root: true });
      await api
        .post(`/attachment?patientId=${id}`, formData, config, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          commit("set_attchmentId", res?.data?.attachmentArr[0].id);
          dispatch("receptionist/listPatients", null, { root: true }).then(
            res => {
              vm.$toasted.show(res.data.message).goAway("3000");
              commit("set_loading", false, { root: true });
            }
          );
        })
        .catch(err => {
          commit("set_loading", false, { root: true });
        });
    } else {
      commit("set_loading", true, { root: true });
      await api
        .post(`/attachment`, formData, config, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          commit("set_attchmentId", res?.data?.attachmentArr[0].id);
          commit("set_attchmentUrl", res?.data?.attachmentArr[0].path);
          vm.$toasted.show(res.data.message).goAway("3000");
          commit("set_loading", false, { root: true });
        })
        .catch(err => {
          commit("set_loading", false, { root: true });
        });
    }
  },
  async forgetPassword({ commit }, payload) {
    await api.post(`/auth/forget-password`, payload);
  },
  async changePassword({ commit }, payload) {
    await api.post(`/auth/change-password`, payload);
  },
  resetUploadProgress({ commit }) {
    commit("upload_progress", null);
  },
  userLoginProgress({ commit }, payload) {
    commit("login_progress", payload);
  }
};

const getters = {
  isLoggedIn: state => state.loggedIn,
  userInfo: state => state.user,
  authStatus: state => state.status,
  role: state => state && state.user && state.user.userRole,
  isOther: state => state && state.user && state.user.isOther,
  attachmentId: state => state.attachmentId,
  attachmentUrl: state => state.attachmentUrl,
  uploadProgress: state => state.uploadProgress,
  errorMessage: state => state.message,
  userErrorMessage: state => state.userMessage,
  loginLoading: state => state.loginLoading,
  updateNotification: state => state.updateNotification,
  showUpdateBanner: state => state.showUpdateBanner,
  validateSessionStatus: state => state.validateSession
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
